var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signpost" },
    [
      _c(
        "v-row",
        { attrs: { variant: "flex" } },
        [
          _c(
            "v-column",
            { attrs: { large: 12 } },
            [
              _c("v-typo", {
                staticClass: "signpost__headline",
                attrs: { variant: "h1" },
                domProps: { innerHTML: _vm._s(_vm.$t("signpost.headline")) }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "signpost__cards", attrs: { variant: "flex" } },
        _vm._l(_vm.signpostCards, function(card) {
          return _c(
            "v-column",
            {
              key: "signpost-card--" + card.type,
              staticClass: "signpost__card",
              attrs: { large: 4 }
            },
            [
              _c("v-signpost-card", {
                attrs: { content: card.head, type: card.type }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }